function cart() {
    const cartBtn = document.querySelectorAll('.add-to-cart');

    if (cartBtn.length > 0) {
        const cart = document.querySelector('.cart');

        //Настройка отображения поапа
        //Показываем корзину при клике на "Добавить в корзину"
        cartBtn.forEach(el=> {
            el.addEventListener('click', (e)=> {
                e.preventDefault();
                cart.classList.add('show');
            });
        });

        //Показываем корзину при клике на кнопку корзины
        document.querySelector('.cart-button').addEventListener('click', (e)=> {
            e.preventDefault();
            cart.classList.add('show');
        });

        //Прячем корзину при клике на cart-hidden и тело корзины
        const closePopup = document.querySelectorAll('.cart-hidden');

        closePopup.forEach(el=> {
            el.addEventListener('click', (e)=> {
                e.preventDefault();
                cart.classList.remove('show');
            });
        });

        document.addEventListener('click', (e)=> {
            if(e.target.classList.contains('cart'))
                cart.classList.remove('show');
        });



        //Функция для очистки корзины
        function clearCartAndLocalStorage() {
            // Очищаем localStorage
            localStorage.removeItem('cartItems');
        
            // Очищаем содержимое корзины на странице
            const orderInfoWrapper = document.querySelector('.cart__product-wrapper');
            orderInfoWrapper.innerHTML = '';
        
            // Обновляем общую стоимость товаров
            mathPrice();
        
            // Убираем класс "in-cart" с body
            document.body.classList.remove('in-cart');
        }

        //Очищаем корзину при переключении языков
        const languageLinks = document.querySelectorAll('.header__lang-link');
        languageLinks.forEach(link => {
            link.addEventListener('click', function (event) {
                clearCartAndLocalStorage();
            });
        });


        // Функция для сохранения значения количества товара в localStorage
        function saveProductCountToLocalStorage(productTitle, count) {
            // Получаем текущие товары из localStorage
            let cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];

            // Находим товар с соответствующим названием и обновляем его количество
            cartItems.forEach(item => {
                if (item.title === productTitle) {
                    item.count = count;
                }
            });

            // Обновляем localStorage с обновленным массивом товаров
            localStorage.setItem('cartItems', JSON.stringify(cartItems));
        }


        // Функция для отображения товаров из localStorage в корзине при загрузке страницы
        function displayCartItemsFromLocalStorage() {
            const orderInfoWrapper = document.querySelector('.cart__product-wrapper');
            orderInfoWrapper.innerHTML = ''; // Очищаем корзину перед добавлением товаров из localStorage

            // Получаем текущие товары из localStorage
            const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];

            // Добавляем каждый товар из localStorage в корзину
            cartItems.forEach(item => {
                let orderInfo = document.createElement('div');
                orderInfo.classList.add('cart__product');

                // Добавляем информацию о товаре в созданный div
                orderInfo.innerHTML = `
                    <span class="cart__product-title">${item.title}</span>
                    <input class="cart__product-count" type="number" value="${item.count}" min="1">
                    <span class="cart__product-price">${item.price}</span>
                    <button class="cart__product-remove" type="button">Удалить</button>
                `;

                orderInfoWrapper.appendChild(orderInfo);
            });

            // Добавляем класс "in-cart" к body, если корзина не пуста
            if (cartItems.length > 0) {
                document.body.classList.add('in-cart');
            }

            // Получаем все инпуты количества товаров
            const productCountInputs = document.querySelectorAll('.cart__product-count');

            // Слушаем изменения в инпутах количества товара и сохраняем новое значение в localStorage
            productCountInputs.forEach(input => {
                input.addEventListener('input', function () {
                    const productTitle = this.closest('.cart__product').querySelector('.cart__product-title').innerText;
                    let inputValue = this.value.trim(); // Удаляем пробелы в начале и конце значения

                    // Проверяем, является ли значение числом
                    if (!isNaN(inputValue) && inputValue !== '') {
                        // Если значение является числом, сохраняем его в localStorage
                        saveProductCountToLocalStorage(productTitle, inputValue);
                    } else {
                        // Если значение не является числом или пусто, устанавливаем значение по умолчанию равным 1
                        inputValue = 1;
                        this.value = inputValue; // Обновляем значение инпута
                        saveProductCountToLocalStorage(productTitle, inputValue); // Сохраняем значение в localStorage
                    }

                    mathPrice(); // Пересчитываем общую стоимость товаров
                });
            });
        }

        // Вызываем функцию для отображения товаров из localStorage при загрузке страницы
        displayCartItemsFromLocalStorage();


        //Функция для подсчета стоимости товаров
        function mathPrice() {
            const products = document.querySelectorAll('.cart__product');
            let totalPrice = 0;
        
            products.forEach(product => {
                const productPrice = parseFloat(product.querySelector('.cart__product-price').innerText);
                const productCount = parseInt(product.querySelector('.cart__product-count').value);

                totalPrice += productPrice * productCount;
            });
        
            //Записываем сумму в нужное поле
            const summField = document.querySelector('.cart__summ-val');
            summField.innerText = totalPrice;
        }

        mathPrice();


        // Добавление товара в корзину и localStorage
        cartBtn.forEach(el => {
            el.addEventListener('click', function () {
                const parent = this.closest('.product-wrapper');
                const productTitle = parent.querySelector('.product-title').innerText;
                const productPrice = parent.querySelector('.product-price').innerText;

                let productCount = 1; // Устанавливаем значение по умолчанию

                // Ищем элемент количества товаров внутри корзины
                const countInput = parent.querySelector('.cart__product-count');
                if (countInput) {
                    productCount = parseInt(countInput.value) || 1; // Если значение не удалось преобразовать в число, устанавливаем значение по умолчанию
                }

                // Получаем текущие товары из localStorage
                let cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];

                // Проверяем, есть ли уже такой товар в корзине
                let existingProduct = cartItems.find(item => item.title === productTitle && item.price === productPrice);

                if (existingProduct) {
                    // Если товар уже есть в корзине, увеличиваем его количество
                    existingProduct.count += productCount;
                } else {
                    // Если товара нет в корзине, добавляем новый
                    const productInfo = {
                        title: productTitle,
                        price: productPrice,
                        count: productCount
                    };
                    cartItems.push(productInfo);
                }

                // Обновляем localStorage с обновленным массивом товаров
                localStorage.setItem('cartItems', JSON.stringify(cartItems));

                // Вызываем функцию для обновления корзины с добавленным товаром
                displayCartItemsFromLocalStorage();

                //Обновляем общую стоимость товаров
                mathPrice();
            });
        });


        // Удаление товара из корзины и localStorage
        document.addEventListener('click', function (e) {
            if (e.target.classList.contains('cart__product-remove')) {
                // Получаем родительский элемент товара
                const parent = e.target.closest('.cart__product');

                // Получаем название и цену товара
                const productTitle = parent.querySelector('.cart__product-title').innerText;
                const productPrice = parent.querySelector('.cart__product-price').innerText;

                // Удаляем товар из DOM
                parent.remove();

                // Получаем текущие товары из localStorage
                let cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];

                // Фильтруем массив товаров, оставляя только те, которые не соответствуют удаляемому товару
                cartItems = cartItems.filter(item => !(item.title === productTitle && item.price === productPrice));

                // Обновляем localStorage с обновленным массивом товаров
                localStorage.setItem('cartItems', JSON.stringify(cartItems));

                //Обновляем общую стоимость товаров
                mathPrice();

                // Закрываем корзину, если товаров в ней больше нет
                const orderInfoWrapper = document.querySelector('.cart__product-wrapper');
                const orderInfoList = orderInfoWrapper.querySelectorAll('.cart__product');

                if (orderInfoList.length === 0) {
                    document.querySelector('.cart').classList.remove('show');
                    document.body.classList.remove('in-cart');
                }
            }
        });
    }
}

export default cart;